/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { ILayoutConfig, LAYOUT_TYPE } from "../../../ui/components/Layout/LayoutTypes";

export const IntegrationEditorCreateLayoutConfig: ILayoutConfig = {
	root: {
		type: LAYOUT_TYPE.ROW,
		id: "layout",
		children: [
			{
				type: LAYOUT_TYPE.PANEL,
				id: "integrations",
				isExpandable: false,
				contentComponent: "integrations",
				size: 3
			},
			{
				type: LAYOUT_TYPE.PANEL,
				id: "details",
				isExpandable: false,
				contentComponent: "details",
				size: 1
			}
		]
	}
};
